import { toast } from "react-toastify";

export enum ToastTypes {
  warning = "warning",
  info = "info",
  success = "success",
  error = "error",
}

type IToastProp =
  | "top-center"
  | "top-right"
  | "top-left"
  | "bottom-right"
  | "bottom-center"
  | "bottom-left"
  | undefined;

export const showToast = (
  message: Array<any>,
  type: string,
  position: IToastProp = "top-center"
) => {
  message.map((mes) => {
    switch (type) {
      case ToastTypes.success:
        toast.success(mes, { position: position });
        break;
      case ToastTypes.error:
        toast.error(mes, { position: position });
        break;
      case ToastTypes.warning:
        toast.warning(mes, { position: position });
        break;
      case ToastTypes.info:
        toast.info(mes, { position: position });
        break;
    }
  });
};



export const SuccessToast = (message = ['عملیات با موفقیت انجام شد']) => {
  showToast(message, ToastTypes.success);
};

export const ErrorToast = (message = ['مشکلی به وجود آمده است']) => {
  showToast(message, ToastTypes.error);
};


export const WarningToast = (message = ['مشکلی به وجود آمده است']) => {
  showToast(message, ToastTypes.warning);
};
